if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.cartNotification = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // START eGift card validate Sender & Recipient details
        const senderEmailField = this.form.querySelector('input[name="properties[sender_email]"]');

        if (senderEmailField) {
          const requiredFields = [
            'properties[sender_email]',
            'properties[recipient_email]',
            'properties[recipient_name]',
            'properties[sender_name]',
          ];

          const isFieldEmpty = requiredFields.some((field) => {
            const input = this.form.querySelector(`input[name="${field}"]`);
            return !input || input.value.trim() === '';
          });

          if (isFieldEmpty) {
            showMessage('Sender & Recipient details are required to continue', 'error');
            return;
          }
        }
        // END eGift card validate Sender & Recipient details

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (this.cartNotification) {
          formData.append(
            'sections',
            this.cartNotification.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cartNotification.setActiveElement(document.activeElement);
        }

        let quantityInCart = 0;
        let currentQuantity = 0;
        let maxQuantity = 0;
        let minQuantity = 1;

        const cartCountElement =
          document.querySelector('.quantity__rules-cart-count') || this.querySelector('.current_quantity--count');
        if (cartCountElement) {
          quantityInCart = parseInt(cartCountElement.dataset.incart, 10);
        }

        for (const [key, value] of formData.entries()) {
          if (key === 'quantity') {
            currentQuantity = parseInt(value, 10);
          }
          if (key === 'max-quantity') {
            maxQuantity = parseInt(value, 10);
          }
          if (key === 'min-quantity') {
            minQuantity = parseInt(value, 10);
          }
        }

        const totalAdding = quantityInCart + currentQuantity;

        if (totalAdding > maxQuantity && maxQuantity != 0) {
          showMessage("You've reached maximum purchase amount for this item", 'error');
          // this.querySelector('.max.error').classList.add('message-active');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        // if (minQuantity > totalAdding) {
        //   showMessage('Please add the miniumum purchase amount', 'error');
        //   // this.querySelector('.min.error').classList.add('message-active');
        //   // document.querySelector('.theme-message').textContent = 'Minimum added';
        //   // document.querySelector('.theme-message').classList.add('active', 'error');
        //   this.submitButton.classList.remove('loading');
        //   this.submitButton.removeAttribute('aria-disabled');
        //   this.querySelector('.loading__spinner').classList.add('hidden');
        //   return;
        // }
        // else {
        //   // this.querySelector('.min.error').classList.remove('message-active');
        //   document.querySelector('.theme-message').textContent = '';
        //   document.querySelector('.theme-message').classList.remove('active', 'error');
        // }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // console.log('add to cart', response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cartNotification.renderContents(response);
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            const headerCartIcon = document.querySelectorAll('.header__icon--cart');

            headerCartIcon.forEach((icon) => {
              if (icon.classList.contains('cart--empty')) icon.classList.remove('cart--empty');
            });

            const pickup_location_id = localStorage.getItem('pickup_location_id');

            if (pickup_location_id != '') {
              const formData = new FormData();
              formData.append('attributes[PickupLocationID]', pickup_location_id);

              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                body: formData,
              });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
